import { render, staticRenderFns } from "./SubmissionFormUpload.vue?vue&type=template&id=311ed6fe&"
import script from "./SubmissionFormUpload.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormUpload.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionFormUpload.vue?vue&type=style&index=0&id=311ed6fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports